export default (params) => ({
  trigger: {
    name: 'timeslot_selection.select_change_content',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'edit_phonenumber',
          'edit_delivery_address',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
      },
    },
  },
});
